import React, { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { getCodigosPostales, patchCodigoPostal, postCodigoPostal } from 'api/catalogos/codigosPostales';
import OSMap from 'components/OSMap';
import Select from 'components/Select';

export const permissionConfig = {
  permissionModel: 'codigopostal',
};

const municipio = 633; // tlajomulco
const tiposAsentamientos = [
  'Aeropuerto', 'Barrio', 'Campamento', 'Colonia', 'Condominio', 'Congregación', 'Conjunto habitacional',
  'Ejido', 'Estación', 'Equipamiento', 'Exhacienda', 'Finca', 'Fraccionamiento', 'Gran usuario',
  'Granja', 'Hacienda', 'Ingenio', 'Parque industrial', 'Poblado comunal', 'Pueblo', 'Ranchería',
  'Residencial', 'Unidad habitacional', 'Villa', 'Zona comercial', 'Zona federal', 'Zona industrial',
  'Ampliación', 'Club de golf', 'Puerto', 'Paraje', 'Zona naval', 'Zona militar', 'Rancho'];

const clavesAsentamientos = [
  1, 2, 4, 9, 10, 11, 12, 15, 16, 17, 18, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
  34, 37, 38, 39, 40, 45, 46, 47, 48,
];

// eslint-disable-next-line react/prop-types
const CodigosPostales = ({ permission }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const selected = data.results.find((e) => e.id === selectedRowKeys[0]);

  const fetchData = async (page = 1, params) => {
    setLoading(true);
    const _data = await getCodigosPostales({ ...params, page, municipio });
    _data.page = page;
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      titleText: 'Código Postal',
      width: 120,
      dataIndex: 'd_codigo',
      key: 'd_codigo',
    },
    {
      titleText: 'Colonia',
      width: 300,
      dataIndex: 'd_asenta',
      key: 'd_asenta',
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
    getCheckboxProps: (r) => ({ disabled: r.estados_globales === 4 }),
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    form.resetFields();
    setVisible(false);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = () => setVisible(true);

  const rules = { required: [{ required: true }] };

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    values.entidad = 1;
    values.pais = 152;
    values.municipio = municipio;
    values.c_cve_ciudad = 11;
    values.c_estado = 14;
    values.c_mnpio = 97;
    values.c_oficina = null;
    values.d_CP = selected?.d_CP || values.d_codigo;
    values.d_ciudad = 'Tlajomulco de Zúñiga';
    values.d_estado = 'Jalisco';
    values.d_mnpio = 'Tlajomulco de Zúñiga';
    values.c_tipo_asenta = clavesAsentamientos[tiposAsentamientos.indexOf(values.d_tipo_asenta)];
    const [key] = selectedRowKeys;
    const saved = await (key
      ? patchCodigoPostal(key, values) : postCodigoPostal(values));
    if (saved) {
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const onLocationSelect = (info) => form.setFieldsValue({ d_codigo: info.name.match(/(\d+)/)?.[0] });

  return (
    <Spin spinning={loading && !visible}>
      {!visible ? (
        <Table
          cols={columns}
          data={data.results}
          controls={{
            onClickAdd,
            onClickEdit,
          }}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
          pagination={false}
          paginationCallback={fetchData}
          count={data.count}
          currentPage={data.page}
          allowSort={false}
          rowKey="id"
          allowColumnSelector={false}
          allowExpand
          mobileColIndex={0}
        />
      ) : (
        <Card
          className="form-container"
          title="Colonia"
          extra={(
            <FormSubmitControls
              onFinish={form.submit}
              onCancel={onCancel}
              loading={loading}
              permission={permission}
            />
          )}
          bordered={false}
        >
          <Form
            name="info"
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Código Postal" name="d_codigo" rules={rules.required}>
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={16}>
                <Form.Item label="Nombre" name="d_asenta" rules={rules.required}>
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Tipo de asentamiento" name="d_tipo_asenta">
                  <Select dataSource={tiposAsentamientos} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Tipo de Zona" name="d_zona">
                  <Select dataSource={['Urbano', 'Rural']} />
                </Form.Item>
              </Col>
              <OSMap onLocationSelect={onLocationSelect} />
            </Row>
          </Form>
        </Card>
      )}
    </Spin>
  );
};

export default CodigosPostales;
